import { Skeleton } from '@reveni-io/reveni-ui'

import { deliveryMethodTypeCards } from '../constants'
import { getVisibleEnabledForCards } from '../helpers'
import * as SharedStyles from '../styles'
import * as Styles from './styles'

const DeliveryMethodDetailConfigurationSkeleton = ({ allowsUnifiedFlow }) => {
  const visibleEnabledForCards = getVisibleEnabledForCards(allowsUnifiedFlow)

  return (
    <Styles.MainContainer>
      <Styles.Section>
        <Skeleton variant="text" width={60} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <SharedStyles.CardsGrid columns={2}>
          {deliveryMethodTypeCards.map(card => {
            return <Skeleton key={card.value} variant="rounded" width="100%" height={76} />
          })}
        </SharedStyles.CardsGrid>
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <SharedStyles.CardsGrid columns={3}>
          {visibleEnabledForCards.map(card => {
            return <Skeleton key={card.value} variant="rounded" width="100%" height={76} />
          })}
        </SharedStyles.CardsGrid>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={120} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>
    </Styles.MainContainer>
  )
}

export default DeliveryMethodDetailConfigurationSkeleton
